import { ThankYouUpsellElementType } from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext } from "react";
import { BrandKitButton } from "../brand-kit-button";
import { Flex } from "../flex";
import { FormElementDrop } from "../form-builder/form-element-drop";
import {
  BrandKitContext,
  ReviewFormSelectionContext,
  SetReviewFormSelectionContext,
  THANK_YOU_UPSELL_PAGE,
} from "./review-form-editor-contexts";
import { ReviewFormPageElement } from "./review-form-page-element";
import {
  getDefaultElement,
  PossibleThankYouPageElement,
  ThankYouPageForm,
} from "./review-form-types";

export const ReviewThankYouUpsellPage = memo(function ReviewThankYouUpsellPage({
  thankYouPage,
}: {
  thankYouPage: ThankYouPageForm;
}) {
  const selectedElement = useContext(ReviewFormSelectionContext);
  const setSelectedElement = useContext(SetReviewFormSelectionContext);

  const brandKit = useContext(BrandKitContext);

  return (
    <>
      <FormElementDrop<ThankYouUpsellElementType>
        elementDropped={(element) => {
          const newElement = getDefaultElement(
            element,
            brandKit,
          ) as PossibleThankYouPageElement;
          thankYouPage.setValue({
            elements: [newElement, ...thankYouPage.value.elements],
          });
        }}
        possibleValues={ThankYouUpsellElementType}
      />
      <Flex dir="column" gap="3xl">
        {thankYouPage.value.elements.map((element, elementIndex) => {
          const isSelected =
            selectedElement.selectedPageIndex === THANK_YOU_UPSELL_PAGE &&
            selectedElement.selectedElementIndex === elementIndex;

          return (
            <Flex dir="column" gap="none" key={elementIndex}>
              <ReviewFormPageElement
                elementIndex={elementIndex}
                isSelected={isSelected}
                props={{
                  element,
                  pageIndex: THANK_YOU_UPSELL_PAGE,
                  page: thankYouPage,
                }}
                selectElement={() => {
                  setSelectedElement({
                    selectedPageIndex: THANK_YOU_UPSELL_PAGE,
                    selectedElementIndex: elementIndex,
                  });
                }}
              />
              <FormElementDrop<ThankYouUpsellElementType>
                elementDropped={(element) => {
                  const newElement = getDefaultElement(
                    element,
                    brandKit,
                  ) as PossibleThankYouPageElement;
                  const elements = thankYouPage.value.elements;
                  const newElements = elements
                    .slice(0, elementIndex + 1)
                    .concat(newElement)
                    .concat(elements.slice(elementIndex + 1));
                  thankYouPage.setValue({ elements: newElements });
                }}
                possibleValues={ThankYouUpsellElementType}
              />
            </Flex>
          );
        })}
      </Flex>
      <BrandKitButton brandKit={brandKit} hierarchy="primary" text="Close" />
    </>
  );
});
